import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProblemSection() {
  const {
    ref: hookRef,
    isVisible: hookVisible
  } = useScrollReveal();
  const {
    ref: problemRef,
    isVisible: problemVisible
  } = useScrollReveal();
  const {
    ref: failRef,
    isVisible: failVisible
  } = useScrollReveal();
  return <>
      {/* Opening Hook */}
      <section className="w-full py-20 px-6" style={{
      background: '#111827'
    }} data-id="element-177">
        <div className="max-w-3xl mx-auto text-center" data-id="element-178">
          <div ref={hookRef} className={`reveal ${hookVisible ? 'visible' : ''}`} data-id="element-179">
            {/* Time indicator */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 border" style={{
            borderColor: 'rgba(212,168,83,0.3)',
            background: 'rgba(212,168,83,0.06)'
          }} data-id="element-180">
              <span style={{
              color: '#D4A853'
            }} data-id="element-181">
                🌙
              </span>
              <span className="text-sm font-medium tracking-wide" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#D4A853'
            }} data-id="element-182">
                23h30
              </span>
            </div>

            <p className="text-xl md:text-2xl leading-relaxed mb-6" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8',
            fontStyle: 'italic'
          }} data-id="element-183">
              "Il est 23h30. La maison est enfin calme. Les enfants dorment.
              Vous devriez être épuisée, mais dès que vous posez la tête sur
              l'oreiller, le{' '}
              <span style={{
              color: '#D4A853'
            }} data-id="element-184">
                "moulin"
              </span>{' '}
              s'active."
            </p>

            <p className="text-base md:text-lg leading-relaxed" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-185">
              Les scénarios catastrophes s'enchaînent, les dialogues imaginaires
              avec votre ex tournent en boucle, et cette boule d'angoisse au
              creux de l'estomac vous hurle que vous n'allez pas y arriver. Vous
              êtes physiquement vidée, mais votre cerveau est à{' '}
              <strong style={{
              color: '#F5F0E8'
            }} data-id="element-186">
                1000 volts.
              </strong>
            </p>
          </div>
        </div>
      </section>

      {/* The Problem */}
      <section className="w-full py-20 px-6" style={{
      background: '#0D1B2A'
    }} data-id="element-187">
        <div className="max-w-3xl mx-auto" data-id="element-188">
          <div ref={problemRef} className={`reveal ${problemVisible ? 'visible' : ''}`} data-id="element-189">
            <div className="amber-divider mb-8" data-id="element-190" />

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8'
          }} data-id="element-191">
              Ce n'est pas un manque de volonté.
            </h2>

            <p className="text-base md:text-lg leading-relaxed text-center mb-10" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-192">
              Ce n'est pas parce que vous êtes "trop stressée". C'est votre
              biologie qui est restée bloquée en mode survie.
            </p>

            {/* Callout box */}
            <div className="rounded-2xl p-6 md:p-8 mb-8 border-l-4" style={{
            background: 'rgba(212,168,83,0.06)',
            borderColor: '#D4A853',
            borderLeftWidth: '4px'
          }} data-id="element-193">
              <p className="text-base md:text-lg leading-relaxed mb-4" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#C8C0B0'
            }} data-id="element-194">
                Après un divorce ou une séparation, votre système nerveux
                perçoit le futur comme une{' '}
                <strong style={{
                color: '#F5F0E8'
              }} data-id="element-195">
                  menace constante
                </strong>
                . Résultat ? Au lieu de produire de la mélatonine pour dormir,
                votre corps injecte une dose massive de{' '}
                <strong style={{
                color: '#D4A853'
              }} data-id="element-196">
                  cortisol
                </strong>{' '}
                (l'hormone du stress) dès que le silence s'installe.
              </p>
              <p className="text-base leading-relaxed" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#C8C0B0'
            }} data-id="element-197">
                Vous essayez de dormir, mais votre corps, lui, se prépare au
                combat.
              </p>
            </div>

            {/* "Fatigue électrique" highlight */}
            <div className="rounded-xl p-6 text-center border" style={{
            background: 'rgba(13,27,42,0.8)',
            borderColor: 'rgba(212,168,83,0.2)'
          }} data-id="element-198">
              <p className="text-sm uppercase tracking-widest mb-2" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-199">
                Ce phénomène s'appelle
              </p>
              <p className="text-2xl md:text-3xl font-bold" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853',
              fontStyle: 'italic'
            }} data-id="element-200">
                "La fatigue électrique"
              </p>
              <p className="text-sm mt-3" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-201">
                L'incapacité totale de décrocher alors que vous rêvez juste de
                fermer les yeux.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why previous solutions failed */}
      <section className="w-full py-20 px-6" style={{
      background: '#111827'
    }} data-id="element-202">
        <div className="max-w-3xl mx-auto" data-id="element-203">
          <div ref={failRef} className={`reveal ${failVisible ? 'visible' : ''}`} data-id="element-204">
            <div className="amber-divider mb-8" data-id="element-205" />
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8'
          }} data-id="element-206">
              Pourquoi rien n'a fonctionné jusqu'ici
            </h2>

            <div className="space-y-5" data-id="element-207">
              {/* Item 1 */}
              <div className="flex gap-5 p-5 rounded-xl" style={{
              background: 'rgba(13,27,42,0.6)',
              border: '1px solid rgba(255,255,255,0.05)'
            }} data-id="element-208">
                <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold" style={{
                background: 'rgba(180,60,60,0.15)',
                color: '#E57373'
              }} data-id="element-209">
                  ✗
                </div>
                <div data-id="element-210">
                  <h3 className="text-base font-semibold mb-1" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#F5F0E8'
                }} data-id="element-211">
                    La méditation classique
                  </h3>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-212">
                    Essayer de rester "zen" quand on a une tempête de cortisol
                    dans le sang est impossible — cela crée encore plus de
                    frustration.
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex gap-5 p-5 rounded-xl" style={{
              background: 'rgba(13,27,42,0.6)',
              border: '1px solid rgba(255,255,255,0.05)'
            }} data-id="element-213">
                <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold" style={{
                background: 'rgba(180,60,60,0.15)',
                color: '#E57373'
              }} data-id="element-214">
                  ✗
                </div>
                <div data-id="element-215">
                  <h3 className="text-base font-semibold mb-1" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#F5F0E8'
                }} data-id="element-216">
                    Les écrans
                  </h3>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-217">
                    Faire défiler Instagram à minuit ne fait qu'indiquer à votre
                    cerveau qu'il doit rester en alerte.
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div className="flex gap-5 p-5 rounded-xl" style={{
              background: 'rgba(13,27,42,0.6)',
              border: '1px solid rgba(255,255,255,0.05)'
            }} data-id="element-218">
                <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold" style={{
                background: 'rgba(180,60,60,0.15)',
                color: '#E57373'
              }} data-id="element-219">
                  ✗
                </div>
                <div data-id="element-220">
                  <h3 className="text-base font-semibold mb-1" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#F5F0E8'
                }} data-id="element-221">
                    Attendre que ça passe
                  </h3>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-222">
                    L'insomnie de séparation ne se règle pas avec le temps —
                    elle s'installe comme une habitude nerveuse destructrice.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}